import { FunctionalComponent, Host, h } from '@stencil/core';
import state from '@ugc-store';
import { stringFormat } from '@ugc-utils/utils';
import { IViewMobile } from './interfaces';
import { LinedRefine } from '../../icons';

const ViewMobile: FunctionalComponent<IViewMobile> = ({ onInput = () => {} }) => {
  const {
    qnaStaticLanguage: { IDS_LBL_SEARCH = '', IDS_UGC_QNA_SEARCH_RESULT_COUNT = '' },
    textToSearch,
    qnaListTotalCount,
    qids,
    isFirstLoad,
  } = state;
  const isShowList = qids.length > 0 || (!isFirstLoad && qids.length === 0);

  // render search input
  const renderSearchInput = (
    <ugc-input
      inputName={IDS_LBL_SEARCH}
      inputValue={textToSearch}
      isShowSearchIcon={true}
      onInputChange={e => onInput(e)}
      style={{ flex: '1' }}
      data-testid="pdp-qna-search"
    />
  );

  // render filter button
  const renderFilterButton = (
    <div
      class="flex-row-end-center p-12 flex-shrink-0 border-1 border-solid border-gray-300 rounded-8"
      data-testid="pdp-qna-refine-button"
      onClick={() => (state.isShowQnaFilterModal = !state.isShowQnaFilterModal)}
    >
      <LinedRefine width="24" height="24" />
    </div>
  );

  // render list total count
  const renderListTotalCount = !isFirstLoad && textToSearch !== '' && (
    <div class="mt-8 fs-14 c-666">{stringFormat(IDS_UGC_QNA_SEARCH_RESULT_COUNT, qnaListTotalCount)}</div>
  );

  return (
    isShowList && (
      <Host>
        <div class="flex-row-between-center gap-10">
          {renderSearchInput}
          {renderFilterButton}
        </div>
        {renderListTotalCount}
      </Host>
    )
  );
};

export default ViewMobile;
